import validate from "/usr/src/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import region_45guard_45global from "/usr/src/app/app/middleware/regionGuard.global.ts";
export const globalMiddleware = [
  validate,
  region_45guard_45global
]
export const namedMiddleware = {
  "not-found-americas": () => import("/usr/src/app/app/middleware/notFoundAmericas.ts"),
  "not-found-brazil": () => import("/usr/src/app/app/middleware/notFoundBrazil.ts"),
  "not-found-france": () => import("/usr/src/app/app/middleware/notFoundFrance.ts"),
  "not-found-germany": () => import("/usr/src/app/app/middleware/notFoundGermany.ts"),
  "not-found-italy": () => import("/usr/src/app/app/middleware/notFoundItaly.ts"),
  "not-found-king-of-kings-nations": () => import("/usr/src/app/app/middleware/notFoundKingOfKingsNations.ts"),
  "not-found-kings": () => import("/usr/src/app/app/middleware/notFoundKings.ts"),
  "not-found-mena": () => import("/usr/src/app/app/middleware/notFoundMena.ts"),
  "not-found-nations": () => import("/usr/src/app/app/middleware/notFoundNations.ts"),
  "not-found-queens": () => import("/usr/src/app/app/middleware/notFoundQueens.ts"),
  "not-found-queens-americas": () => import("/usr/src/app/app/middleware/notFoundQueensAmericas.ts"),
  "not-found-spain": () => import("/usr/src/app/app/middleware/notFoundSpain.ts"),
  "not-found-world-cup": () => import("/usr/src/app/app/middleware/notFoundWorldCup.ts"),
  "validation-news-guard": () => import("/usr/src/app/app/middleware/validationNewsGuard.ts")
}